import { useEffect } from 'react';
import useRequest from '@gp/hooks/useRequest';
import { reportSearchOperationLog, reportBtnOperationLog } from '@gp/utils/common';

import {
  // 查询搜索记录
  queryRecord as queryRecords,
  // 添加搜索记录
  pushRecord,
  // 删除搜索记录
  deleteRecord,
} from '@gp/services/project';

/**
 *
 * @param domain 搜索记录业务类型（区分不同页面的搜索记录）
 */
export default function useSearchRecords(
  domain: number,
  props?: {
    searchLogKey?: string;
    deleteSearchBtnLogKey?: string;
  },
) {
  const { searchLogKey, deleteSearchBtnLogKey } = props || {};

  const {
    loading: searchRecordsLoading,
    data: searchRecords,
    run: runQueryRecords,
    refresh: refreshQueryRecords,
  } = useRequest(queryRecords, { manual: true });

  const { runAsync: runPushRecordAsync } = useRequest(pushRecord, { manual: true });

  const { runAsync: runDeleteRecordAsync } = useRequest(deleteRecord, { manual: true });

  const handlePushRecord = async (payload: string) => {
    try {
      await runPushRecordAsync({
        type: domain,
        // @ts-ignore
        name: payload,
      });
      refreshQueryRecords();
    } finally {
    }
    reportSearchOperationLog(searchLogKey, { query: payload, clickId: '' });
  };

  const handleDeleteRecord = async (payload: { id: string; name: string }) => {
    const { id, name } = payload || {};
    try {
      await runDeleteRecordAsync({ id });
      refreshQueryRecords();
    } finally {
    }
    reportBtnOperationLog(deleteSearchBtnLogKey, { extInfo: name });
  };

  useEffect(() => {
    runQueryRecords({ type: domain });
  }, [domain]);

  return {
    searchRecordsLoading,
    searchRecords,
    onPushRecord: handlePushRecord,
    onDeleteRecord: handleDeleteRecord,
  };
}
